module.exports = __webpack_public_path__ + "assets/d8831bdc542b4a22fc61a81678641cc2.mp3";